import { connect } from "react-redux";
import LastTransactions from "./LastTransactions";
import { actions } from "./actions";

export default connect(
  state => ({ lastTransactions: state.lastTransactions }),
  actions
)(LastTransactions);
